import {iCmp} from "../../../../misc/utils";
import {PartMenuType} from "../../../visComponents/constants";
import Layer from "../../../visComponents/layer";
import PartCommon from "../../../visComponents/partCommon";

export class Part extends PartCommon {

  constructor(isParent, isChild, menuType) {
    super();
    if (isChild || (isParent && menuType === PartMenuType.Simple)) {
      this.featuresList = {
        Large: [],
        Small: []
      };
      this.featuresPartsList = {
        Large: [],
        Small: []
      };
      this.allFeaturesReceived = false;
      this.realFeaturesReceived = false; // this prop is need on Scroll (if features count more that 1000)
      this.nextFeaturesPageToLoad = 0;
      this.activeFeature = null;
      this.placeholderFeature = null;
      this.shadowFeature = null;
      this.placeholderChanged = false;
      this.firstClick = {
        "0": false // first quote
      };
      this.activeLockedFeature = null;
      this.activeNotInVisualizerFeature = null; // is needed to display in the QT selected activeNotInVisualizerFeature, but render proper activeFeature layer(for example, countertop)
      // name = "";
      this.visible = true;
      this.categoryEnabled = false;
      this.layout = null;
      this.featureGroupVisible = true;  // dashboard's feature group eye ball logic
      this.featureGroupEnabled = true;  // dashboard's feature group checkbox logic
      this.filtersReceived = null; // array of filters values, comes from BE, for ex [1221, 347, 1124]
    }
    if (isParent) {
      this.partThumbnail = '';
      this.relatedItems = [];
    }
    if (!isChild && !isParent) {
      this.dbFeature = null;
      this.layer = new Layer("bv");
      this._customDisplayName = null;
      this.notesList = {};
    }
    this.partName = "";
  }

  set features(featuresList) {
    // features can't be set directly, we need to change featuresList array
  }
  get features() {
    const layout = this.layout || this.getParent().layout;
    return this.featuresList[layout.getCurrentLayoutName()]
  }
  set featuresParts(featuresList) {
    // featuresParts can't be set directly, we need to change featuresPartsList array
  }
  get featuresParts() {
    const layout = this.layout || this.getParent().layout;
    return this.featuresPartsList[layout.getCurrentLayoutName()]
  }

  featureClicked() {
    this.updateLocalStorage();
    // other specific events, for ex. Google Analytics, etc.
  }

  /**
   * Checks whether a given for condition matches the needed value (or array of values)
   * @param name {string}
   * @param value {string || array}
   * @returns  {int} -1 - no such for condition, 0 - no match, 1 - matches
   */
  matchesMetaForCondition(name, value) {
    return this.metaData[name] && this.metaData[name].some(condValue => {
      return Array.isArray(value) ? value.some(val => iCmp(condValue, val, true)) : iCmp(condValue, value, true)
    });
  }

  matchesMetaForArrayOfConditions(arrayOfConditions) {
    return arrayOfConditions.every((condition) => {
      let conditionPassed = this.matchesMetaForCondition(condition.propName, condition.propValue);
      if (condition.propName === "EX L" && !conditionPassed) {
        conditionPassed = this.matchesMetaForCondition( "Wall", condition.propValue);
      } else if (condition.propName === "Size" && condition.propValue === "60in" && Array.isArray(this.metaData["Size"])
        && this.metaData["Size"].includes("30in")) {
        conditionPassed = false
      }
      return conditionPassed
    })
  }
}


